import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { UsersComponent } from './users.component';
import { usersRoutes } from './users.routes';
import { UsersService } from './users.service';
import { UserDetailsComponent } from './user-details/user-details.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserExistsInviteComponent } from './user-exists-invite/user-exists-invite.component';
import { UserNewInviteComponent } from './user-new-invite/user-new-invite.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { usersReducer } from './users.reducer';
import { UsersEffects } from './users.effects';
import { UsersResolve } from './users.resolve';
import { UsersStatsResolve } from './users-stats.resolve';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    LayoutModule,
    TranslateModule,
    RouterModule.forChild(usersRoutes),
    StoreModule.forFeature('users', usersReducer),
    EffectsModule.forFeature([UsersEffects])
  ],
  declarations: [
    UsersComponent,
    UserDetailsComponent,
    UserEditComponent,
    UserExistsInviteComponent,
    UserNewInviteComponent
  ],
  providers: [UsersService, UsersResolve, UsersStatsResolve],
  exports: [],
  entryComponents: []
})
export class UsersModule {}
